
import ApiService from "@/services/api.service";
import { defineComponent, computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "LoginPage",
  components: {},
  setup() {
    const form = ref({ email: "", password: "", server: "" });

    onMounted(() => {
      const email = localStorage.getItem("email");
      const password = localStorage.getItem("password");
      const server = localStorage.getItem("server");

      form.value = {
        email: email || "auto56@teachermail.org",
        password: password || "p4ssw0rd",
        server: server || "https://pmx2dev3.cloud02.corp",
      };
    });

    const store = useStore();

    const sid = computed(() => store.getters["auth/getSid"]);

    function submit() {
      login();
    }

    async function login() {
      const { email, password, server } = form.value;

      localStorage.setItem("email", email);
      localStorage.setItem("password", password);
      localStorage.setItem("server", server);

      await ApiService.init(`${server}/api`, store);

      const credentials = { email, password };
      store.dispatch("auth/login", credentials);
    }

    return {
      submit,
      sid,
      isAuthenticating: computed(() => store.getters["auth/isAuthenticating"]),
      form,
    };
  },
});
